/* ============================================================
   PATCHISTRY ARCADE — "PATCH DROP"
   Hidden easter egg. Click the Patchistry logo 5 times to launch.
   The hat catches falling patches. 90s arcade energy — CRT scanlines,
   pixel font, synth bleeps, high-score table. The brand's core mechanic
   (hat = canvas, patches drop in) turned into a game.
   ============================================================ */
(function () {
  'use strict';

  var HIGH_SCORE_KEY = 'pchstr_arcade_hi';
  var CLICKS_TO_LAUNCH = 5;
  var CLICK_WINDOW_MS = 2500;

  var noMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Patch images: read from JSON the theme renders, else fallback ──────────
  function loadPatchImageUrls() {
    var urls = [];
    var el = document.getElementById('pchstr-arcade-patches');
    if (el) {
      try { urls = JSON.parse(el.textContent) || []; } catch (e) {}
    }
    // Fallback: scrape any patch imagery already on the page
    if (!urls.length) {
      document.querySelectorAll('.pcr-patch-img, .pps__collage-tile, .pmr__storm-patch').forEach(function (n) {
        var src = n.getAttribute('src');
        if (!src) {
          var bg = (n.style && n.style.backgroundImage) || '';
          var m = bg.match(/url\(["']?(.*?)["']?\)/);
          if (m) src = m[1];
        }
        if (src && urls.indexOf(src) === -1) urls.push(src);
      });
    }
    return urls.slice(0, 24);
  }

  // ── Tiny synth — arcade bleeps via Web Audio, no files ─────────────────────
  var audioCtx = null;
  function beep(freq, dur, type, vol) {
    if (noMotion) return;
    try {
      if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      var o = audioCtx.createOscillator();
      var g = audioCtx.createGain();
      o.type = type || 'square';
      o.frequency.value = freq;
      g.gain.value = vol == null ? 0.06 : vol;
      o.connect(g); g.connect(audioCtx.destination);
      o.start();
      g.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + (dur || 0.08));
      o.stop(audioCtx.currentTime + (dur || 0.08));
    } catch (e) {}
  }
  function sndCatch() { beep(880, 0.07, 'square', 0.05); setTimeout(function(){ beep(1320, 0.06, 'square', 0.04); }, 40); }
  function sndGold()  { [660, 880, 1100, 1480].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.08, 'square', 0.05); }, i * 55); }); }
  function sndMiss()  { beep(160, 0.18, 'sawtooth', 0.05); }
  function sndStart() { [523, 659, 784, 1047].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.1, 'square', 0.05); }, i * 90); }); }
  function sndOver()  { [523, 440, 349, 262].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.16, 'sawtooth', 0.05); }, i * 140); }); }
  function sndShoot() { beep(1200, 0.04, 'square', 0.025); }
  function sndPower() { [659, 880, 1175].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.07, 'triangle', 0.05); }, i * 50); }); }
  function sndEnemyFire() { beep(220, 0.05, 'sawtooth', 0.03); }
  function sndCapture() { [600, 500, 400, 300, 220].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.12, 'sawtooth', 0.05); }, i * 80); }); }
  function sndRescue() { [523, 659, 784, 1047, 1319].forEach(function(f, i){ setTimeout(function(){ beep(f, 0.12, 'square', 0.06); }, i * 90); }); }

  // ── Styles + pixel font ────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('pchstr-arcade-styles')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Press+Start+2P&display=swap';
    document.head.appendChild(link);

    var s = document.createElement('style');
    s.id = 'pchstr-arcade-styles';
    s.textContent = [
      '.pa-overlay{position:fixed;inset:0;z-index:2147483600;background:#0a0612;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .4s ease;font-family:"Press Start 2P",monospace}',
      '.pa-overlay.is-on{opacity:1}',
      '.pa-stage{position:relative;width:min(92vw,520px);height:min(86vh,720px);background:linear-gradient(180deg,#1a0f2e 0%,#0a0612 100%);border:4px solid #ff2e88;border-radius:10px;box-shadow:0 0 0 4px #1a0f2e,0 0 48px rgba(255,46,136,.5),0 0 120px rgba(108,46,232,.4);overflow:hidden}',
      '.pa-canvas{display:block;width:100%;height:100%;image-rendering:pixelated}',
      // CRT scanlines + vignette
      '.pa-crt{position:absolute;inset:0;pointer-events:none;z-index:5;background:repeating-linear-gradient(180deg,rgba(0,0,0,0) 0,rgba(0,0,0,0) 2px,rgba(0,0,0,.18) 3px,rgba(0,0,0,0) 4px);mix-blend-mode:multiply}',
      '.pa-crt::after{content:"";position:absolute;inset:0;background:radial-gradient(ellipse at center,transparent 55%,rgba(0,0,0,.55) 100%)}',
      // HUD
      '.pa-hud{position:absolute;top:0;left:0;right:0;z-index:6;display:flex;justify-content:space-between;padding:14px 16px;color:#7CF5FF;font-size:9px;text-shadow:0 0 8px rgba(124,245,255,.7);letter-spacing:1px;pointer-events:none}',
      '.pa-hud .pa-gold{color:#FFD23F;text-shadow:0 0 8px rgba(255,210,63,.8)}',
      '.pa-lives{color:#ff2e88;text-shadow:0 0 8px rgba(255,46,136,.7)}',
      // Screens (start / over)
      '.pa-screen{position:absolute;inset:0;z-index:7;display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;padding:24px;color:#fff;gap:20px}',
      '.pa-title{font-size:26px;line-height:1.3;color:#ff2e88;text-shadow:3px 3px 0 #6c2ee8,0 0 24px rgba(255,46,136,.6)}',
      '.pa-sub{font-size:9px;line-height:2;color:#7CF5FF;text-shadow:0 0 8px rgba(124,245,255,.6)}',
      '.pa-press{font-size:11px;color:#FFD23F;text-shadow:0 0 12px rgba(255,210,63,.8);animation:pa-blink 1s steps(2) infinite}',
      '@keyframes pa-blink{50%{opacity:0}}',
      '.pa-btn{font-family:"Press Start 2P",monospace;font-size:10px;background:#ff2e88;color:#0a0612;border:none;padding:14px 20px;cursor:pointer;box-shadow:4px 4px 0 #6c2ee8;transition:transform .1s,box-shadow .1s}',
      '.pa-btn:active{transform:translate(4px,4px);box-shadow:0 0 0 #6c2ee8}',
      '.pa-score-big{font-size:20px;color:#FFD23F;text-shadow:0 0 16px rgba(255,210,63,.7)}',
      '.pa-hi{font-size:9px;color:#7CF5FF}',
      '.pa-new-hi{font-size:11px;color:#ff2e88;animation:pa-blink .6s steps(2) infinite}',
      '.pa-close{position:absolute;top:10px;right:12px;z-index:8;background:none;border:none;color:rgba(255,255,255,.5);font-family:"Press Start 2P",monospace;font-size:12px;cursor:pointer;padding:6px}',
      '.pa-close:hover{color:#ff2e88}',
      '.pa-hint{position:absolute;bottom:12px;left:0;right:0;z-index:6;text-align:center;color:rgba(255,255,255,.4);font-size:7px;letter-spacing:1px}',
      '.pa-power{position:absolute;top:34px;left:0;right:0;z-index:6;text-align:center;color:#FFD23F;font-size:9px;letter-spacing:2px;text-shadow:0 0 8px rgba(255,210,63,.8);pointer-events:none}',
      '@media (prefers-reduced-motion: reduce){.pa-press,.pa-new-hi{animation:none}}'
    ].join('\n');
    document.head.appendChild(s);
  }

  // ── Game ─────────────────────────────────────────────────────────────────
  var GAME = null;

  function launch() {
    if (GAME) return;
    injectStyles();
    sndStart();

    var patchUrls = loadPatchImageUrls();

    var overlay = document.createElement('div');
    overlay.className = 'pa-overlay';
    overlay.innerHTML =
      '<div class="pa-stage">' +
        '<canvas class="pa-canvas"></canvas>' +
        '<div class="pa-crt"></div>' +
        '<div class="pa-hud" style="display:none">' +
          '<span>SCORE <b class="pa-score">0</b></span>' +
          '<span class="pa-gold">WAVE <b class="pa-wave">1</b></span>' +
          '<span class="pa-lives">&#9829;&#9829;&#9829;</span>' +
        '</div>' +
        '<div class="pa-power" style="display:none"></div>' +
        '<div class="pa-hint" style="display:none">&#8592; &#8594; MOVE &bull; SPACE/TAP FIRES &bull; ESC QUITS</div>' +
        '<button class="pa-close" aria-label="Close">&#10005;</button>' +
        '<div class="pa-screen pa-start">' +
          '<div class="pa-title">PATCH<br>DROP</div>' +
          '<div class="pa-sub">HOOK THE SWARM<br>DODGE THEIR FIRE<br><br>GOLD DROPS POWER-UPS<br>RESCUE A CAPTURED HAT<br>FOR DUAL FIRE</div>' +
          '<button class="pa-btn pa-play">PRESS START</button>' +
          '<div class="pa-hi">HI ' + (parseInt(localStorage.getItem(HIGH_SCORE_KEY) || '0', 10)) + '</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-on'); });

    var stage = overlay.querySelector('.pa-stage');
    var canvas = overlay.querySelector('.pa-canvas');
    var ctx = canvas.getContext('2d');
    var hud = overlay.querySelector('.pa-hud');
    var hint = overlay.querySelector('.pa-hint');
    var powerEl = overlay.querySelector('.pa-power');
    var scoreEl = overlay.querySelector('.pa-score');
    var waveEl = overlay.querySelector('.pa-wave');
    var livesEl = overlay.querySelector('.pa-lives');
    var startScreen = overlay.querySelector('.pa-start');

    var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      var r = stage.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = W * DPR; canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);

    var imgs = [];
    patchUrls.forEach(function (u) { var im = new Image(); im.crossOrigin = 'anonymous'; im.src = u; imgs.push(im); });
    function pickImg() { return imgs.length ? imgs[Math.floor(Math.random() * imgs.length)] : null; }

    // cubic bezier helper
    function bez(t, a, b, c, d) {
      var mt = 1 - t;
      return mt*mt*mt*a + 3*mt*mt*t*b + 3*mt*t*t*c + t*t*t*d;
    }

    // ── State ──
    var state = 'start';
    var hatW = 70, hatH = 46, hatY = 0;
    var hats = [{ x: 0 }];          // 1 normally, 2 when dual
    var bullets = [];               // player hooks {x,y}
    var eBullets = [];              // enemy projectiles {x,y,vy,vx}
    var powerups = [];              // {x,y,vy,type}
    var floaters = [];
    var formation = [];
    var sway = 0, diveTimer = 0, score = 0, lives = 3, wave = 1, combo = 0, fireCD = 0;
    var keys = { left: false, right: false, fire: false };
    var power = { rapid: 0, spread: 0, slow: 0 };
    var shield = false;
    var captureHolder = null;       // boss patch currently holding a captured hat

    var POWER_TYPES = ['rapid', 'spread', 'shield', 'slow'];
    var POWER_LABEL = { rapid: 'R', spread: '3', shield: 'S', slow: '~' };
    var POWER_NAME = { rapid: 'RAPID FIRE', spread: 'SPREAD SHOT', shield: 'SHIELD', slow: 'SLOW-MO', dual: 'DUAL HAT' };

    function buildWave(w) {
      formation = [];
      captureHolder = null;
      var cols = Math.min(7, 5 + Math.floor(w / 3));
      var rows = Math.min(4, 2 + Math.floor(w / 2));
      var cellW = Math.min(58, (W - 50) / cols);
      var startX = (W - (cols - 1) * cellW) / 2;
      var topY = 64;
      var idx = 0;
      for (var r = 0; r < rows; r++) {
        for (var c = 0; c < cols; c++) {
          var isBoss = (r === 0 && (c === Math.floor(cols / 2)) && w >= 1);
          var isGold = !isBoss && Math.random() < 0.14;
          var slotX = startX + c * cellW, slotY = topY + r * 46;
          var fromLeft = (idx % 2 === 0);
          formation.push({
            slotX: slotX, slotY: slotY,
            x: fromLeft ? -50 : W + 50, y: -40,
            size: isBoss ? 46 : (isGold ? 40 : 32),
            img: pickImg(),
            kind: isBoss ? 'boss' : (isGold ? 'gold' : 'small'),
            alive: true,
            state: 'enter',
            entryT: 0,
            entryDelay: idx * 90,
            // entry curve control points
            p0x: fromLeft ? -50 : W + 50, p0y: -40,
            p1x: fromLeft ? W * 0.8 : W * 0.2, p1y: H * 0.42,
            p2x: slotX + (fromLeft ? 70 : -70), p2y: slotY + 90,
            diveT: 0, fromX: 0, fromY: 0, targetX: 0,
            beam: 0, holdingHat: false, fireT: 600 + Math.random() * 1200
          });
          idx++;
        }
      }
    }

    function reset() {
      bullets = []; eBullets = []; powerups = []; floaters = [];
      score = 0; lives = 3; wave = 1; combo = 0; sway = 0; diveTimer = 0; fireCD = 0;
      hats = [{ x: W / 2 }];
      power = { rapid: 0, spread: 0, slow: 0 }; shield = false; captureHolder = null;
      scoreEl.textContent = '0'; waveEl.textContent = '1'; livesEl.innerHTML = '♥♥♥';
      buildWave(1);
    }

    function startGame() {
      reset(); state = 'play';
      startScreen.style.display = 'none';
      hud.style.display = 'flex'; hint.style.display = 'block';
      last = performance.now();
      requestAnimationFrame(loop);
    }

    function updatePowerHud() {
      var bits = [];
      if (shield) bits.push('🛡');
      if (power.rapid > 0) bits.push('R');
      if (power.spread > 0) bits.push('3X');
      if (power.slow > 0) bits.push('~');
      if (hats.length > 1) bits.push('DUAL');
      powerEl.textContent = bits.join('  ');
      powerEl.style.display = bits.length ? 'block' : 'none';
    }

    function fire() {
      if (fireCD > 0) return;
      fireCD = power.rapid > 0 ? 120 : 240;
      hats.forEach(function (h) {
        if (power.spread > 0) {
          bullets.push({ x: h.x, y: hatY - hatH, vx: -0.18 });
          bullets.push({ x: h.x, y: hatY - hatH, vx: 0 });
          bullets.push({ x: h.x, y: hatY - hatH, vx: 0.18 });
        } else {
          bullets.push({ x: h.x, y: hatY - hatH, vx: 0 });
        }
      });
      sndShoot();
    }

    function loseLife() {
      if (shield) { shield = false; updatePowerHud(); flash('SHIELD!', hats[0].x, hatY - 30, '#7CF5FF'); return; }
      // lose dual hat first if we have it
      if (hats.length > 1) { hats.pop(); updatePowerHud(); flash('-1 HAT', hats[0].x, hatY - 30, '#ff2e88'); sndMiss(); return; }
      lives--;
      livesEl.innerHTML = new Array(Math.max(0, lives) + 1).join('♥') || '&#128148;';
      sndMiss();
      if (lives <= 0) gameOver();
    }

    function startDive(p) {
      p.diveT = 0; p.fromX = p.x; p.fromY = p.y;
      p.targetX = hats[0].x + (Math.random() - 0.5) * 100;
      p.state = (p.kind === 'boss' && !captureHolder && hats.length === 1 && Math.random() < 0.6) ? 'beam' : 'dive';
    }

    function applyPower(type) {
      sndPower();
      if (type === 'shield') { shield = true; }
      else if (type === 'rapid') { power.rapid = 7000; }
      else if (type === 'spread') { power.spread = 7000; }
      else if (type === 'slow') { power.slow = 5000; }
      flash(POWER_NAME[type] + '!', hats[0].x, hatY - 36, '#FFD23F');
      updatePowerHud();
    }

    function flash(text, x, y, color) { floaters.push({ text: text, x: x, y: y, life: 1, color: color }); }

    function drawHat(x, y, dim) {
      ctx.save(); ctx.translate(x, y);
      if (shield) {
        ctx.strokeStyle = 'rgba(124,245,255,0.7)'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(2, -hatH * 0.4, hatW * 0.62, 0, Math.PI * 2); ctx.stroke();
      }
      ctx.globalAlpha = dim ? 0.4 : 1;
      ctx.fillStyle = '#F5EFE4';
      ctx.beginPath();
      ctx.moveTo(-hatW / 2 + 10, 0);
      ctx.quadraticCurveTo(0, -hatH, hatW / 2 - 10, 0);
      ctx.lineTo(hatW / 2 - 10, 6); ctx.lineTo(-hatW / 2 + 10, 6);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#1C1208';
      ctx.beginPath(); ctx.ellipse(4, 8, hatW / 2, 7, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#FFD23F';
      ctx.beginPath(); ctx.arc(0, -hatH * 0.55, 4, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    }

    function drawPatch(p) {
      ctx.save(); ctx.translate(p.x, p.y);
      if (p.kind === 'boss') {
        ctx.shadowColor = '#ff2e88'; ctx.shadowBlur = 16;
        ctx.strokeStyle = '#ff2e88'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(0, 0, p.size / 1.5, 0, Math.PI * 2); ctx.stroke();
      } else if (p.kind === 'gold') {
        ctx.shadowColor = '#FFD23F'; ctx.shadowBlur = 14;
        ctx.fillStyle = 'rgba(255,210,63,0.16)';
        ctx.beginPath(); ctx.arc(0, 0, p.size / 1.5, 0, Math.PI * 2); ctx.fill();
      }
      if (p.img && p.img.complete && p.img.naturalWidth) {
        ctx.drawImage(p.img, -p.size / 2, -p.size / 2, p.size, p.size);
      } else {
        ctx.fillStyle = p.kind === 'gold' ? '#FFD23F' : (p.kind === 'boss' ? '#ff2e88' : '#c98cff');
        ctx.beginPath(); ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2); ctx.fill();
      }
      ctx.restore();
      // captured hat riding the boss
      if (p.holdingHat) drawHat(p.x, p.y + p.size / 2 + 18, true);
    }

    var last = performance.now();
    function loop(now) {
      if (state !== 'play') return;
      var dt = Math.min(now - last, 50); last = now;
      hatY = H - 52;
      var slowF = power.slow > 0 ? 0.5 : 1;

      // timers
      ['rapid', 'spread', 'slow'].forEach(function (k) { if (power[k] > 0) { power[k] -= dt; if (power[k] <= 0) updatePowerHud(); } });
      fireCD -= dt;

      // hat movement (primary hat leads; dual follows offset)
      var hs = 0.55 * dt;
      if (keys.left) hats[0].x -= hs;
      if (keys.right) hats[0].x += hs;
      hats[0].x = Math.max(hatW / 2, Math.min(W - hatW / 2, hats[0].x));
      if (hats[1]) hats[1].x = Math.max(hatW / 2, Math.min(W - hatW / 2, hats[0].x + 30));
      if (hats[1]) hats[0]._lx = hats[0].x; // keep ref
      if (keys.fire) fire();

      sway += dt * 0.0009;
      diveTimer -= dt;

      ctx.clearRect(0, 0, W, H);

      // counts
      var alive = 0, settled = 0;
      formation.forEach(function (p) { if (p.alive) { alive++; if (p.state === 'form') settled++; } });

      if (diveTimer <= 0 && settled > 0) {
        diveTimer = Math.max(420, 1500 - wave * 110);
        var cands = formation.filter(function (p) { return p.alive && p.state === 'form'; });
        if (cands.length) startDive(cands[Math.floor(Math.random() * cands.length)]);
      }

      // player bullets
      for (var b = bullets.length - 1; b >= 0; b--) {
        var bl = bullets[b];
        bl.y -= 0.7 * dt; bl.x += (bl.vx || 0) * dt;
        if (bl.y < -10 || bl.x < -10 || bl.x > W + 10) { bullets.splice(b, 1); continue; }
        ctx.fillStyle = '#7CF5FF'; ctx.shadowColor = '#7CF5FF'; ctx.shadowBlur = 8;
        ctx.fillRect(bl.x - 2, bl.y - 8, 4, 12); ctx.shadowBlur = 0;
      }

      // enemy bullets
      for (var eb = eBullets.length - 1; eb >= 0; eb--) {
        var e = eBullets[eb];
        e.y += e.vy * dt * slowF; e.x += (e.vx || 0) * dt;
        if (e.y > H + 10) { eBullets.splice(eb, 1); continue; }
        ctx.fillStyle = '#ff5a5a'; ctx.shadowColor = '#ff2e88'; ctx.shadowBlur = 6;
        ctx.beginPath(); ctx.arc(e.x, e.y, 4, 0, Math.PI * 2); ctx.fill(); ctx.shadowBlur = 0;
        // hit a hat?
        for (var hi = 0; hi < hats.length; hi++) {
          if (Math.abs(e.x - hats[hi].x) < hatW / 2 - 6 && Math.abs(e.y - hatY) < 22) {
            eBullets.splice(eb, 1); loseLife(); if (state !== 'play') return; break;
          }
        }
      }

      // powerups falling
      for (var pu = powerups.length - 1; pu >= 0; pu--) {
        var u = powerups[pu];
        u.y += u.vy * dt;
        if (u.y > H + 20) { powerups.splice(pu, 1); continue; }
        ctx.save(); ctx.translate(u.x, u.y);
        ctx.fillStyle = '#FFD23F'; ctx.shadowColor = '#FFD23F'; ctx.shadowBlur = 12;
        ctx.beginPath(); ctx.arc(0, 0, 12, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#0a0612'; ctx.font = 'bold 12px "Press Start 2P", monospace';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText(POWER_LABEL[u.type], 0, 1); ctx.restore();
        ctx.textBaseline = 'alphabetic';
        for (var h2 = 0; h2 < hats.length; h2++) {
          if (Math.abs(u.x - hats[h2].x) < hatW / 2 && Math.abs(u.y - hatY) < 24) {
            applyPower(u.type); powerups.splice(pu, 1); break;
          }
        }
      }

      // formation
      var swayX = Math.sin(sway) * 16;
      for (var i = 0; i < formation.length; i++) {
        var p = formation[i];
        if (!p.alive) continue;

        if (p.state === 'enter') {
          if (p.entryDelay > 0) { p.entryDelay -= dt; }
          else {
            p.entryT += dt / 1500;
            if (p.entryT >= 1) { p.entryT = 1; p.state = 'form'; }
            var t = p.entryT;
            p.x = bez(t, p.p0x, p.p1x, p.p2x, p.slotX);
            p.y = bez(t, p.p0y, p.p1y, p.p2y, p.slotY);
          }
        } else if (p.state === 'form') {
          p.x = p.slotX + swayX; p.y = p.slotY;
          // occasional enemy fire from settled patches
          p.fireT -= dt;
          if (p.fireT <= 0) {
            p.fireT = 2500 + Math.random() * 3000;
            if (Math.random() < 0.5 && p.y < H * 0.5) {
              eBullets.push({ x: p.x, y: p.y + p.size / 2, vy: 0.32 + wave * 0.02, vx: (hats[0].x - p.x) * 0.0004 });
              sndEnemyFire();
            }
          }
        } else if (p.state === 'dive') {
          p.diveT += dt; var prog = Math.min(1, p.diveT / 2400);
          p.y = p.fromY + (H + 60 - p.fromY) * prog;
          p.x = p.fromX + (p.targetX - p.fromX) * prog + Math.sin(prog * Math.PI * 3) * 38;
          if (Math.random() < 0.012 && prog < 0.7) { eBullets.push({ x: p.x, y: p.y + 10, vy: 0.4, vx: 0 }); sndEnemyFire(); }
          if (p.y > H + 40) { p.state = 'enter'; p.entryT = 0; p.entryDelay = 0; p.x = p.slotX; p.y = -40; p.p0x = p.slotX; p.p0y = -40; p.p1x = p.slotX; p.p1y = -20; p.p2x = p.slotX; p.p2y = p.slotY - 30; loseLife(); if (state !== 'play') return; }
        } else if (p.state === 'beam') {
          p.diveT += dt; var bp = Math.min(1, p.diveT / 1600);
          p.y = p.fromY + (H * 0.42 - p.fromY) * bp;
          p.x = p.fromX + (p.targetX - p.fromX) * bp;
          if (bp >= 1) {
            p.beam += dt;
            // draw beam cone
            ctx.save();
            var grad = ctx.createLinearGradient(0, p.y, 0, hatY);
            grad.addColorStop(0, 'rgba(255,46,136,0.35)'); grad.addColorStop(1, 'rgba(255,46,136,0.04)');
            ctx.fillStyle = grad;
            ctx.beginPath();
            ctx.moveTo(p.x - 10, p.y); ctx.lineTo(p.x + 10, p.y);
            ctx.lineTo(p.x + 46, hatY); ctx.lineTo(p.x - 46, hatY);
            ctx.closePath(); ctx.fill(); ctx.restore();
            // capture if a hat sits in the beam ~900ms
            for (var hc = 0; hc < hats.length; hc++) {
              if (Math.abs(hats[hc].x - p.x) < 46 && p.beam > 900) {
                p.holdingHat = true; p.state = 'enter'; p.entryT = 0.6; captureHolder = p;
                p.p0x = p.x; p.p0y = p.y;
                sndCapture(); flash('CAPTURED!', p.x, p.y, '#ff2e88');
                loseLife(); if (state !== 'play') return;
                break;
              }
            }
            if (p.beam > 2200) { p.state = 'enter'; p.entryT = 0.5; p.p0x = p.x; p.p0y = p.y; } // give up
          }
        }

        // bullet collisions
        for (var b2 = bullets.length - 1; b2 >= 0; b2--) {
          var bb = bullets[b2];
          var dx = bb.x - p.x, dy = bb.y - p.y;
          if (dx * dx + dy * dy < (p.size / 2 + 6) * (p.size / 2 + 6)) {
            bullets.splice(b2, 1);
            // rescue!
            if (p.holdingHat) {
              p.alive = false; captureHolder = null;
              if (hats.length < 2) hats.push({ x: hats[0].x + 30 });
              sndRescue(); flash('DUAL HAT!', p.x, p.y, '#FFD23F');
              updatePowerHud();
              score += 200; scoreEl.textContent = score;
              break;
            }
            p.alive = false; combo++;
            var base = p.kind === 'boss' ? 80 : (p.kind === 'gold' ? 50 : 10);
            var pts = base * Math.max(1, Math.floor(combo / 4) + 1);
            score += pts; scoreEl.textContent = score;
            flash('+' + pts, p.x, p.y, p.kind === 'small' ? '#7CF5FF' : '#FFD23F');
            if (p.kind === 'small') sndCatch(); else sndGold();
            // gold/boss may drop a power-up
            if ((p.kind === 'gold' && Math.random() < 0.5) || (p.kind === 'boss' && Math.random() < 0.8)) {
              powerups.push({ x: p.x, y: p.y, vy: 0.18, type: POWER_TYPES[Math.floor(Math.random() * POWER_TYPES.length)] });
            }
            break;
          }
        }

        if (p.alive) drawPatch(p);

        // diving patch body hits hat
        if (p.alive && (p.state === 'dive') && Math.abs(p.y - hatY) < 22) {
          for (var hh = 0; hh < hats.length; hh++) {
            if (Math.abs(p.x - hats[hh].x) < hatW / 2) {
              p.state = 'enter'; p.entryT = 0; p.x = p.slotX; p.y = -40; p.p0x = p.slotX; p.p0y = -40; p.p1x = p.slotX; p.p1y = -20; p.p2x = p.slotX; p.p2y = p.slotY - 30;
              loseLife(); if (state !== 'play') return; break;
            }
          }
        }
      }

      // floaters
      for (var f = floaters.length - 1; f >= 0; f--) {
        var fl = floaters[f];
        fl.y -= 0.03 * dt; fl.life -= dt / 850;
        if (fl.life <= 0) { floaters.splice(f, 1); continue; }
        ctx.save(); ctx.globalAlpha = Math.max(0, fl.life);
        ctx.fillStyle = fl.color; ctx.font = '10px "Press Start 2P", monospace';
        ctx.textAlign = 'center'; ctx.fillText(fl.text, fl.x, fl.y); ctx.restore();
      }

      // hats
      hats.forEach(function (h) { drawHat(h.x, hatY, false); });

      if (alive === 0) {
        wave++; waveEl.textContent = wave;
        flash('WAVE ' + wave, W / 2, H / 2, '#ff2e88');
        buildWave(wave);
      }

      requestAnimationFrame(loop);
    }

    function gameOver() {
      state = 'over'; sndOver();
      var hi = parseInt(localStorage.getItem(HIGH_SCORE_KEY) || '0', 10);
      var isNew = score > hi;
      if (isNew) localStorage.setItem(HIGH_SCORE_KEY, String(score));
      hud.style.display = 'none'; hint.style.display = 'none'; powerEl.style.display = 'none';
      var over = document.createElement('div');
      over.className = 'pa-screen pa-over';
      over.innerHTML =
        '<div class="pa-title" style="font-size:20px">GAME<br>OVER</div>' +
        '<div class="pa-score-big">' + score + '</div>' +
        (isNew ? '<div class="pa-new-hi">NEW HIGH SCORE!</div>' : '<div class="pa-hi">HI ' + Math.max(hi, score) + '</div>') +
        '<button class="pa-btn pa-again">PLAY AGAIN</button>' +
        '<div class="pa-sub" style="font-size:7px">BUILD YOURS FOR REAL &#8594;<br>PATCHISTRY.COM</div>';
      stage.appendChild(over);
      over.querySelector('.pa-again').addEventListener('click', function () { stage.removeChild(over); startGame(); });
    }

    function onKey(e, down) {
      if (e.key === 'ArrowLeft' || e.key === 'a') { keys.left = down; e.preventDefault(); }
      if (e.key === 'ArrowRight' || e.key === 'd') { keys.right = down; e.preventDefault(); }
      if (e.key === ' ') { keys.fire = down; if (down) fire(); e.preventDefault(); }
      if (e.key === 'Escape' && down) close();
      if (e.key === 'Enter' && down && state !== 'play') startGame();
    }
    var kd = function (e) { onKey(e, true); }, ku = function (e) { onKey(e, false); };
    document.addEventListener('keydown', kd);
    document.addEventListener('keyup', ku);

    function pointerMove(clientX) {
      var r = stage.getBoundingClientRect();
      hats[0].x = Math.max(hatW / 2, Math.min(W - hatW / 2, clientX - r.left));
      keys.left = keys.right = false;
    }
    var mm = function (e) { if (state === 'play') pointerMove(e.clientX); };
    var md = function () { if (state === 'play') fire(); };
    var ts = function (e) { if (state === 'play' && e.touches[0]) { pointerMove(e.touches[0].clientX); fire(); e.preventDefault(); } };
    var tm = function (e) { if (state === 'play' && e.touches[0]) { pointerMove(e.touches[0].clientX); e.preventDefault(); } };
    stage.addEventListener('mousemove', mm);
    stage.addEventListener('mousedown', md);
    stage.addEventListener('touchstart', ts, { passive: false });
    stage.addEventListener('touchmove', tm, { passive: false });

    var tilt = function (e) {
      if (state !== 'play' || e.gamma == null) return;
      hats[0].x += e.gamma * 0.4;
      hats[0].x = Math.max(hatW / 2, Math.min(W - hatW / 2, hats[0].x));
      keys.left = keys.right = false;
    };
    window.addEventListener('deviceorientation', tilt);

    overlay.querySelector('.pa-play').addEventListener('click', startGame);
    overlay.querySelector('.pa-close').addEventListener('click', close);

    function close() {
      document.removeEventListener('keydown', kd);
      document.removeEventListener('keyup', ku);
      window.removeEventListener('deviceorientation', tilt);
      window.removeEventListener('resize', resize);
      overlay.classList.remove('is-on');
      document.body.style.overflow = '';
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); GAME = null; }, 400);
    }

    GAME = { close: close };
  }

  // ── Logo trigger: 5 clicks within a window ─────────────────────────────────
  function wireTrigger() {
    var clicks = 0, timer = null;
    function onLogoClick() {
      clicks++;
      clearTimeout(timer);
      timer = setTimeout(function () { clicks = 0; }, CLICK_WINDOW_MS);
      if (clicks >= CLICKS_TO_LAUNCH) {
        clicks = 0;
        launch();
      }
    }
    // Delegate so it works regardless of which logo element / page
    document.addEventListener('click', function (e) {
      var logo = e.target.closest('.p-header-logo, .pmr__logo-link, [data-pchstr-logo]');
      if (logo) onLogoClick();
    });
    // Secret keyboard combo too: type "PATCH"
    var seq = '', target = 'patch';
    document.addEventListener('keydown', function (e) {
      if (e.key && e.key.length === 1) {
        seq = (seq + e.key.toLowerCase()).slice(-target.length);
        if (seq === target) launch();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireTrigger);
  } else { wireTrigger(); }
})();
